/*
 * Copyright (C) 2025.  SimpliCity Digital Inc - All Rights Reserved
 */

import { useContext } from "react";
import { SimpliCityAuthContext } from "../simplicity-auth-context.jsx";

const useAuth = () => {

    const context = useContext(SimpliCityAuthContext);

    if (!context) {
        throw new Error("context must be used inside provider");
    }

    return context;
};

export { useAuth };
